import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { Row, Col, Form, notification } from "antd";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { FormComponentProps } from "antd/lib/form";
import { ContainerWrapper } from "src/components/common/ContainerWrapper/ContainerWrapper";
import { ParagraphMedium } from "src/components/common/Paragraphs/Paragraphs";
import { AuthContext } from "src/components/context/AuthContext";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import EmailConfirm from "./EmailConfirm";
import "./Login.scss";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import { FacebookLoginButton } from "src/components/common/Facebook/FacebookLoginButton";
import { GoogleLoginButton } from "src/components/common/Google/GoogleLoginButton";
import ChangePasswordRequired from "src/components/common/ChangePasswordRequired/ChangePasswordRequired";
import { Arrow } from "../../components/common/icons";
import Button from "../../components/common/Button";
import { contato } from "src/util/constants";
import { ServiceContext } from "src/services/provider/Service.provider";
import { Modal } from 'antd';
import { ICommonDomain } from "../../services/interfaces/ICommonDomain";

function Login(props: RouteComponentProps<any> & FormComponentProps) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [newPasswordRequiredUser, setNewPasswordRequiredUser] = useState(null);
  const [passwordMigrationCommonDomain, setPasswordMigrationCommonDomain] = useState<ICommonDomain>(null);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const authContext = useContext(AuthContext);
  const { userService } = useContext(ServiceContext);

  const handleShowPassword = () => {
    setShowPassword(s => !s);
  };

  useEffect(() => {
    userService.getMigrationPasswordChange()
      .then(commonDomain => {
        setPasswordMigrationCommonDomain(commonDomain);
      });
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const userAlreadyResetPassword = await userService.getUserAlreadyResetPassword(email);
    await authContext.signIn(email, password).then(async () => {
      if (passwordMigrationCommonDomain?.isActive && !userAlreadyResetPassword) {
        await userService.setUserAlreadyResetPassword(email);
      }
    })
      .catch((err) => {
        if (err.code === "UserNotConfirmedException") {
          setConfirmEmail(true);
        } else if (err.challengeName === "NEW_PASSWORD_REQUIRED") {
          setNewPasswordRequiredUser(err);
        } else {
          if (err.message !== "Usuário Inativo") {
            if (passwordMigrationCommonDomain?.isActive && !userAlreadyResetPassword) {
              authContext.resetPasswodCognito(email);
              setShowResetPasswordModal(true);
            } else {
              notification.error({
                message: "Falha ao entrar",
                description: "Não foi possí­vel entrar com as informações fornecidas, por favor, verifique e tente novamente."
              });
            }
          } else if (err.message === "Usuário Inativo") {
            notification.warn({
              message: "Usuário Inativo",
              description: "Por favor, contatar administração."
            });
          }
        }
      }).finally(() => {
        setLoading(false);
      });
  }

  async function onRequestRecoveryConfirmed(newPass) {
    userService.setUserAlreadyResetPassword(email).then(resp => {
      if (resp) {
        authContext.signIn(email, newPass);
      }
    }).catch((err) => {
      notification.warn({
        message: "Usuário Inativo",
        description: "Não foi possí­vel entrar com as informações fornecidas, por favor, verifique e tente novamente."
      });
    })
  }
  return (
    <>
      <Modal
        className="modal-change-password-warning"
        title={passwordMigrationCommonDomain?.content?.title}
        visible={showResetPasswordModal}
        onOk={() => setShowResetPasswordModal(false)}
        closable={false}
        footer={[
          <Button key="ok-button" type="primary" onClick={() => setShowResetPasswordModal(false)}>Ok</Button>
        ]}
      >
        <p>{passwordMigrationCommonDomain?.content?.message}</p>
      </Modal>

      {(confirmEmail && (
        <div className="decode-confirm-page">
          <EmailConfirm email={email} password={password} />
        </div>
      )) ||
        (newPasswordRequiredUser && (
          <ChangePasswordRequired
            user={newPasswordRequiredUser}
            pass={password}
            onConfirmed={onRequestRecoveryConfirmed}
          />
        )) || (
          <ContainerWrapper className="login">
            <Row type="flex" align="middle" justify="center">
              <Col xs={24} sm={24} md={24} lg={24}>
                <h2 className="decode-login__title">
                  Entre com sua conta para ver <strong>seus precatórios</strong>.
                </h2>
                <Arrow styles={{ width: "20px", position: "relative", top: "14px", left: "calc(99%/2)", transform: "translateX(-49%) rotate(90deg)", fill: "#ffd735" }} />
                <Form onSubmit={e => handleSubmit(e)} className="login-form" style={{ marginTop: "calc(50px - 0.5em)" }}>
                  <PbrInput
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    name="email"
                    title="Informe um e-mail válido"
                    formItemProps={{ label: "" }}
                    placeholder="E-mail"
                    formWrapper={props.form}
                    rules={[
                      {
                        required: true,
                        message: "Informe um e-mail",
                        pattern: emailRegex
                      }
                    ]}
                  />
                  <div style={{ position: 'relative' }}>
                    <PbrInput
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      name="senha"
                      type={showPassword ? 'text' : 'password'}
                      title="Informe a sua senha"
                      formItemProps={{ label: "" }}
                      placeholder="Senha"
                      formWrapper={props.form}
                      rules={[
                        {
                          required: true,
                          message: "Informe sua senha"
                        }
                      ]}
                    />
                    <Button
                      onClick={handleShowPassword}
                      style={{
                        position: 'absolute',
                        top: 1,
                        right: 1,
                        border: 'none'
                      }}
                      icon={showPassword ? "eye-invisible" : "eye"}
                    />
                  </div>

                  <Row className="actions-btn-row" gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <Button loading={loading}>Entrar</Button>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} className="col-registry">
                      <span className="decode-login-actions">
                        <Link to="recuperar-senha">Esqueci a senha</Link>
                        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                        <Link to="/consulta">Fazer cadastro</Link>
                      </span>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div
                        style={{
                          position: "relative",
                          textAlign: "center",
                          width: "100%",
                          maxWidth: "324px",
                          margin: "0 auto"
                        }}
                      >
                        <ParagraphMedium
                          style={{
                            margin: "40px 0",
                            padding: "0 15px",
                            zIndex: 1,
                            display: "inline-block",
                            position: "relative",
                            backgroundColor: "#FFF",
                            fontSize: "16px",
                            color: "#aeaeae",
                            fontFamily: "Lato",
                            fontWeight: 300
                          }}
                        >
                          OU
                        </ParagraphMedium>
                        <PbrSeparator
                          style={{
                            zIndex: 0,
                            position: "absolute",
                            top: "50%",
                            width: "100%",
                            margin: 0
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <FacebookLoginButton onLoggedIn={() => props.history.push("/consulta")} />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: "29px" }}>
                      <GoogleLoginButton onLoggedIn={guser => props.history.push("/consulta")} />
                    </Col>
                  </Row>

                  <ParagraphMedium style={{ textAlign: "center", margin: "66px 0 0", fontSize: "16px" }}>Precisa de ajuda para acessar?</ParagraphMedium>
                  <ParagraphMedium style={{ textAlign: "center", margin: 0, fontSize: "16px", lineHeight: 1 }}>
                    Mande um e-mail para
                    <a href={`mailto:${contato.email}`}> {contato.email}</a>
                  </ParagraphMedium>
                </Form>
              </Col>
            </Row>
          </ContainerWrapper>
        )}
    </>
  );
}
export default withRouter(Form.create()(Login) as any);



// WEBPACK FOOTER //
// ./src/pages/auth/Login.tsx